import type { ColorClassResolver } from '../helpers/color-class';
import type { Color } from '@precon-tools-suite-by-shared/precon-graphql-types';
import { toValue, type MaybeRefOrGetter } from 'vue';
import type { ColorTint } from '../helpers/normalizeColor';
import { colorClass } from '../helpers/color-class';

export function useColorClass(
    color: MaybeRefOrGetter<Color>
): ColorClassResolver {
    const resolver = (prefix: string, tint: ColorTint | 'none' = '500') =>
        colorClass(prefix, toValue(color), tint);

    return Object.assign(resolver, {
        text: (tint: ColorTint | 'none' = '500') => resolver('text', tint),
        bg: (tint: ColorTint | 'none' = '500') => resolver('bg', tint),
        border: (tint: ColorTint | 'none' = '500') => resolver('border', tint),
    }) as ColorClassResolver;
}
